import { Component, AfterViewInit, Input, ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'al-findmore',
    templateUrl: './al-findmore.component.html'
})

export class AlFindmoreComponent implements AfterViewInit {

    // set component data
    @Input() data: any[];

    // Text for Find More strip
    @Input() findmoreStripText: string = 'Find More';

    // Text for suggestions
    @Input() suggestionStringText: string = 'Suggestions';

    // Find more suggestion number value
    @Input() suggestionNumber: number = 3;

    // Showing text (SHOW_VISIBLE)
    @Input() showingText: string = 'Showing';

    // Dash (-) symbol
    @Input() dashSymbol: string = '-';

    // of text
    @Input() ofText: string = 'of';

    // Find more strip accessibility text
    @Input() findmoreStripAccessibilityText: string = 'Select this link to view more information';

    // Goto previous page accessibility Text
    @Input() gotoPrevText: string = 'Select this link to view the previous page';

    // Goto next page accessibility Text
    @Input() gotoNextText: string = 'Select this link to view the next page';

    // find more strip at bottom
    showFindmore: boolean = false;

    // find more content
    showFindmoreContent: boolean = false;

    // open / close arrow display
    showOpen: boolean = false;

    // pager object
    pager: any = {};

    // paged items
    pagedItems: any[];

    // set scroll timer
    scrollTimer: any;

    /**
     * @constructs
     * Setting constructor method and required param
     *
     * @param cdr
     */
    constructor(private cdr: ChangeDetectorRef) { }

    /**
     * Checking find more flyout view is initialized or not
     * @event ngAfterViewInit
     */
    /* istanbul ignore next */
    ngAfterViewInit() {
        window.addEventListener('scroll', () => {
            if (this.scrollTimer) {
                clearTimeout(this.scrollTimer);
            }
            this.scrollTimer = setTimeout(() => {
                this.toggleFindMoreTray();
            }, 100);

        });

        // initialize to page 1
        this.setPage(1);
    }

    /**
     * Set the display of find more flyout tray when user scroll down at bottom of the page
     * @method toggleFindMoreTray
     */
    toggleFindMoreTray() {
        /* istanbul ignore else */
        if ((window.innerHeight + window.pageYOffset + 5) >= document.body.offsetHeight) {
            this.showFindmore = true;
        } else {
            this.showFindmore = false;
            this.showOpen = false;
            this.showFindmoreContent = false;
        }
    }

    /**
     * setPage method for scrolling between pages of find more flyout
     * @method setPage
     * @param page value of the page number
     */
    setPage(page: number) {
        /* istanbul ignore if */
        if (page < 1 || page > this.pager.totalPages) {
            return;
        }

        // get data object from service
        this.pager = this.getPager(this.data.length, page);

        // get current page of items
        this.pagedItems = this.data.slice(this.pager.startIndex, this.pager.endIndex + 1);
        this.cdr.detectChanges();
    }

    /**
     * Toggle display of flyout content when user click on findmore tray
     * @method showContent
     * @param event
     */
    showContent(event) {
        this.showOpen = !this.showOpen;
        this.showFindmoreContent = !this.showFindmoreContent;
    }

    /**
     * This method counts the length of data and return object with required values like page size, total pages, start page end page etc..
     * @method getPager
     * @param totalItems total items available for find more flyout
     * @param currentPage page number for current page
     */
    getPager(totalItems: number, currentPage: number = 1, pageSize: number = 3) {
        // calculate total pages
        let totalPages = Math.ceil(totalItems / pageSize);
        let startPage: number = 1, endPage: number = totalPages;

        // calculate start and end item indexes
        let startIndex = (currentPage - 1) * pageSize;
        let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // create an array of pages to ng-repeat in the pager control
        let pages = Array.from(Array(endPage + 1 - startPage), (_, i) => startPage + i);

        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }

}
